import {RedeemChannelType} from "@/Core/Redeem/RedeemChannelType";

export default class RedeemUtil {

    static getChannelTypeName(channelType: number) {
        let name = '';
        switch (channelType) {
            case RedeemChannelType.Card:
                name = 'card';
                break;
            case RedeemChannelType.Paypal:
                name = 'paypal';
                break;
            case RedeemChannelType.CashApp:
                name = 'cash_app';
                break;
            case RedeemChannelType.ApmAch:
                name = 'apm_ach';
                break;
            case RedeemChannelType.ApmMazooma:
                name = 'apm_mazooma';
                break;
        }
        return name;
    }

    static getChannelName(channelType: number) {
        let name = '';
        switch (channelType) {
            case RedeemChannelType.Card:
                name = 'Card';
                break;
            case RedeemChannelType.Paypal:
                name = 'Paypal';
                break;
            case RedeemChannelType.CashApp:
                name = 'CashApp';
                break;
            case RedeemChannelType.ApmAch:
                name = 'ApmAch';
                break;
            case RedeemChannelType.ApmMazooma:
                name = 'ApmMazooma';
                break;
        }
        return name;
    }

}